"use client";

// 공용 LocaleProvider/useLocale 재노출 (@kkeut/ui/locale-context).
// 기존 guro 전용 "새 탭 진입 시 ko 강제(sessionStorage)" 동작은 제거하고
// 다른 25개 지점과 동일한 표준 동작(선택 언어 유지)으로 통일.
export { LocaleProvider, useLocale } from "@kkeut/ui/locale-context";
